import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'mdbreact/dist/css/mdb.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import 'jquery';

import './index.css';
import './styles/app.css';
import App from './app/app';
import AppLoader from './utils/AppLoader';
import ScrollToTop from './utils/ScrollToTop';
import { ToastContainer, Flip } from 'react-toastify';
import { UserProvider } from './context/user_context';
import { ThemeProvider } from './context/theme_context';
import { AuthProvider } from './context/auth_context';
import { DashboardProvider } from './context/dashboard_context';
import { ExpensesProvider } from './context/expenses_context';
import { SupplierProvider } from './context/supplier_context';
import { ItemProvider } from './context/item_context';
import { InventoryProvider } from './context/inventory_context';
import { SalesProvider } from './context/sales_context';
import { InvoiceProvider } from './context/invoice_context';
import { DebtProvider } from './context/debt_context';
import { PackagesProvider } from './context/packages_context';
import { EmployeeProvider } from './context/employee_context';
import { CustomerProvider } from './context/customer_context';
import { WaybillProvider } from './context/waybill_context';
import { ReportProvider } from './context/report_context';
import { WebSocketProvider } from './context/web_socket_context';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <UserProvider>
          <AuthProvider>
            <DashboardProvider>
              <ExpensesProvider>
                <SupplierProvider>
                  <ItemProvider>
                    <InventoryProvider>
                      <WaybillProvider>
                        <SalesProvider>
                          <ReportProvider>
                            <InvoiceProvider>
                              <DebtProvider>
                                <PackagesProvider>
                                  <EmployeeProvider>
                                    <CustomerProvider>
                                      <WebSocketProvider>

                                        <ScrollToTop />
                                        <App />
                                        <ToastContainer
                                          hideProgressBar={true}
                                          autoClose={1500}
                                          theme="colored"
                                          newestOnTop
                                          transition={Flip}
                                        />
                                        <AppLoader />
                                      </WebSocketProvider>
                                    </CustomerProvider>
                                  </EmployeeProvider>
                                </PackagesProvider>
                              </DebtProvider>
                            </InvoiceProvider>
                          </ReportProvider>
                        </SalesProvider>
                      </WaybillProvider>
                    </InventoryProvider>
                  </ItemProvider>
                </SupplierProvider>
              </ExpensesProvider>
            </DashboardProvider>
          </AuthProvider>
        </UserProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);